import React, { FunctionComponent, ReactElement } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { OverlayTriggerType } from 'react-bootstrap/OverlayTrigger';
import styles from './styles.module.scss';
import { concat } from '../../common/helpers/arrayHelper';

interface IProps {
  children: ReactElement;
  content: JSX.Element | string;
  placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end';
  trigger?: OverlayTriggerType[] | OverlayTriggerType;
  className?: string;
}

const Tooltip: FunctionComponent<IProps> = ({ placement = 'bottom', content, trigger, className, children }) => (
  <OverlayTrigger
    placement={placement}
    trigger={trigger}
    overlay={(
      <Popover id="tooltip" className={concat(styles.tooltip, className)}>
        {content}
      </Popover>
      )}
  >
    {children}
  </OverlayTrigger>
);

export default Tooltip;
